<template>
  <div class="stat-summary" style="max-width: 50rem;">
    <div class="text-color-space text--medium">{{ $t('widgets.StatSummary.statistics') }}</div>

    <total-sales class="reset-indent"></total-sales>
    <commission class="reset-indent"></commission>
    <gold-shop class="reset-indent" v-if="ShowGoldShopStatistics"></gold-shop>
    <gold-shop-users class="reset-indent" v-if="ShowRegisteredUsers"></gold-shop-users>
  </div>
</template>

<script>
import TotalSales from './TotalSales'
import GoldShop from './GoldShop'
import Commission from './Commission'
import GoldShopUsers from './GoldShopUsers'

import toCurrency from '@/mixins/toCurrency'
import { ShowRegisteredUsers, ShowGoldShopStatistics } from '@/mixins/displayRules'

export default {
  mixins: [toCurrency, ShowRegisteredUsers, ShowGoldShopStatistics],

  components: {
    TotalSales,
    Commission,
    GoldShop,
    GoldShopUsers
  },

  apollo: {}
}
</script>
